/* eslint-disable no-template-curly-in-string */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PROJECT_STATUS_APROVADO } from '../../library/ProjectStatus';
import { Col } from '../Col';
import { Row } from '../Row';
import { getParsedNewLines } from '../../utils/HTMLUtils';
import moment from 'moment';

import styles from './EvaluationItem.scss';

const rootClassName = styles.rootClassName;

class EvaluationItem extends Component {
  getStatusClassName() {
    let className = rootClassName + '-status ' + rootClassName + '-status-';
    if (this.props.historyItem.status === PROJECT_STATUS_APROVADO) {
      return className + 'aprovado';
    }
    return className + 'rejeitado';
  }

  getStatus() {
    if (this.props.historyItem.status === PROJECT_STATUS_APROVADO) {
      return this.props.languageValues.projectStatusAprovado;
    }
    return this.props.languageValues.projectStatusRejeitado;
  }

  render() {
    const data = this.props.historyItem.dataCadastro
      ? moment(this.props.historyItem.dataCadastro).format('DD/MM/YYYY HH:mm')
      : '';

    return (
      <Row className={rootClassName}>
        <Col cols={[12, 12, 12, 12, 12]}>
          <div>
            <span className={this.getStatusClassName()}>
              {this.getStatus()}
            </span>
            <span className={rootClassName + '-date'}>{data}</span>
            <br />
            <p className={rootClassName + '-assessor'}>
              {this.props.languageValues.stepsHistoryFor
                .split('${1}')
                .join(this.props.historyItem.nomeAssessor)}
            </p>
            {this.props.historyItem.comentario &&
            this.props.historyItem.comentario.length > 0 ? (
              <p className={rootClassName + '-comentario'}>
                {getParsedNewLines(this.props.historyItem.comentario.trim())}
              </p>
            ) : (
              ''
            )}
          </div>
        </Col>
      </Row>
    );
  }
}

EvaluationItem.propTypes = {
  index: PropTypes.number.isRequired,
  historyItem: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationItem);
